import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1EmployeeAdminPositionIDOCToArray} from "../../../../util/Payload";
import {v4 as uuidv4} from "uuid";

class EmployeeAdminPositionEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.Employee-004";

        let qbe = btoa(JSON.stringify({
            "ShifamedMessage": {
                "-idoc": "v1.Employee-004",
                "-id": uuidv4(),
                "Employee": {
                    "_attributes": {
                        "limit": 1,
                        "sort": null,
                        "offset": 0
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "QG1",
                                "Type": "QueryGroup",
                                "Operator": "AND",
                                "Membership": {
                                    "Member": [
                                        {
                                            "Type": "Attribute",
                                            "Name": "USID",
                                            "Value": foreignKey,
                                            "Operator": "EQUAL"
                                        }
                                    ]
                                }
                            }
                        ]
                    },
                    "AdminPosition": {
                        "_attributes": {
                            "limit": pageSize,
                            "sort": this.getFormattedSortSpecification(),
                            "offset": (page - 1) * pageSize
                        }
                    }
                }
            }
        }))

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/employees",
            json: true,
            params: {
                "QBE": qbe
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1EmployeeAdminPositionIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let employee = {};

        employee["USID"] = this.getEnterpriseObject().getEnterpriseComponent("Employee").getAttributeValue("USID");
        employee["AdminPosition"] = {
            "USID": this.getAttributeValue("USID")
        }

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.Employee-004";
        payload.ShifamedMessage.Employee = employee;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/employees",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.Employee-004",
                "idoc-response": "v1.Employee-004"
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1EmployeeAdminPositionIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {
            "ShifamedMessage": {
                "-idoc": "v1.Employee-004",
                "Employee": {
                    "_attributes": {
                        "delete": false
                    },
                    "USID": this.getEnterpriseObject().getEnterpriseComponent("Employee").getAttributeValue("USID"),
                    "AdminPosition": {
                        "_attributes": {
                            "delete": true
                        },
                        "USID": this.getAttributeValue("USID")
                    }
                }
            }
        }

        let options = {
            method: "DELETE",
            url: "t3/v1/employees",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.Employee-004"
            },
        };
        this.notifyDeleteStartListeners();
        EnlilAxiosRestAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default EmployeeAdminPositionEnterpriseComponent;